
import Vue from 'vue';
import Component from "vue-class-component";
import { Tr } from "@/i18n/i18n";
import PlayerStore from "@/store/player";
import { Prop } from 'vue-property-decorator';
import { Settings } from '@/constants/settings';
import {IntegrationUtils} from "@/utils/integration-utils";

@Component
export default class MessageOptions extends Vue {
      get trAnswer() { return Tr('answer'); }
      get trDelete() { return Tr('delete.message'); }
      get trCopy() { return Tr('copy.msg'); }
      get trEdit() { return Tr('edit'); }
      get trBlock() { return Tr('block'); }

      private readonly forwardedMessagePrefix = Settings.FORWARDED_MESSAGE_PREFIX;
      private readonly isQuoteEnabled = Settings.CHAT_QUOTE_ENABLED;
      @Prop({ default: 1 }) private accessLevel!: number;
      @Prop() private roomId!: string;
      private outsideClickListenerAttached: boolean = false;
      private fixedMode: boolean = false;
      private originalParentEl: HTMLElement | null = null;
      private originalNextSibling: ChildNode | null = null;

      get numberOfElements() {
            // @ts-ignore
            return this.$refs.body.querySelectorAll(':not([style*="display: none"])').length;
      }

      get canDeleteMassage() {
            // @ts-ignore
            return this.$parent.isModerator && this.roomId !== Settings.PRIVAT_CHAT_ROOM;
      }

      get canAnswer() {
            // @ts-ignore
            return !this.$parent.isSmileyClass;
      }

      get isSmiley() {
            // @ts-ignore
            return this.$parent.isSmileyClass ? 'isSmiley' : '';
      }

      private answer(): void {
            this.$emit("answerCallback")
            this.setDisable();
      }

      private copy(): void {
            // @ts-ignore
            let messageText = this.$parent.messageText;
            
            if (messageText.includes(this.forwardedMessagePrefix)) {
                  const splitMessege = messageText.split(this.forwardedMessagePrefix);
                  messageText = splitMessege[splitMessege.length - 1];
            }

            IntegrationUtils.copyToClipboard(messageText);
            this.setDisable();
      }

      private edit(): void {
            console.log("edit");
      }

      private deleteMassage(): void {
            this.$emit("deleteCallback")
            this.setDisable();
      }

      private block(): void {
            console.log("block");
      }

      public setVisible(offsetX: number, offsetY: number) {
            const messageOptionsIsAvailable = PlayerStore.getPlayer()!.level >= this.accessLevel;
            
            if (messageOptionsIsAvailable && this.numberOfElements > 0) {

                  // @ts-ignore
                  this.$refs.wrapper.classList.add('open');
                  // @ts-ignore
                  this.$refs.wrapper.style.left = offsetX + 'px';
                  // @ts-ignore
                  this.$refs.wrapper.style.top = offsetY + 'px';
                  // @ts-ignore
                  this.$refs.wrapper.style.marginTop = -8 - (6 * (this.numberOfElements - 1)) + 'vh';

                  this.attachOutsideClickListener();
            }
      }

      public setVisibleByClient(clientX: number, clientY: number) {
            const messageOptionsIsAvailable = PlayerStore.getPlayer()!.level >= this.accessLevel;
            if (!messageOptionsIsAvailable || this.numberOfElements <= 0) return;

            this.enableFixedMode();

            // @ts-ignore
            this.$refs.wrapper.classList.add('open');
            this.attachOutsideClickListener();

            this.$nextTick(() => {
                  // @ts-ignore
                  const el = this.$refs.wrapper as HTMLElement | undefined;
                  if (!el) return;

                  const rect = el.getBoundingClientRect();
                  const margin = 8;

                  // Prefer above cursor, but if not enough space - place below
                  const preferTop = clientY - rect.height - margin;
                  const placeBelow = clientY + margin;
                  const top = preferTop >= 0 ? preferTop : placeBelow;

                  const left = clientX - rect.width / 2;

                  const clampedLeft = Math.max(margin, Math.min(left, window.innerWidth - rect.width - margin));
                  const clampedTop = Math.max(margin, Math.min(top, window.innerHeight - rect.height - margin));

                  el.style.left = `${clampedLeft}px`;
                  el.style.top = `${clampedTop}px`;
            });
      }

      public setDisable() {
            // @ts-ignore
            this.$refs.wrapper.classList.remove('open');
            this.detachOutsideClickListener();
            this.disableFixedMode();
      }

      private enableFixedMode() {
            if (this.fixedMode) return;
            // @ts-ignore
            const el = this.$refs.wrapper as HTMLElement | undefined;
            if (!el) return;
            this.originalParentEl = el.parentElement;
            this.originalNextSibling = el.nextSibling;
            document.body.appendChild(el);

            el.style.position = 'fixed';
            el.style.margin = '0';
            // reset possible leftovers from "absolute" mode
            el.style.marginTop = '0';
            el.style.left = '0';
            el.style.top = '0';
            this.fixedMode = true;
      }

      private disableFixedMode() {
            if (!this.fixedMode) return;
            // @ts-ignore
            const el = this.$refs.wrapper as HTMLElement | undefined;
            if (!el) return;

            // restore styles
            el.style.position = '';
            el.style.margin = '';
            el.style.left = '';
            el.style.top = '';
            el.style.marginTop = '';

            // restore DOM position (best-effort)
            if (this.originalParentEl) {
                  if (this.originalNextSibling && this.originalParentEl.contains(this.originalNextSibling)) {
                        this.originalParentEl.insertBefore(el, this.originalNextSibling);
                  } else {
                        this.originalParentEl.appendChild(el);
                  }
            }

            this.originalParentEl = null;
            this.originalNextSibling = null;
            this.fixedMode = false;
      }

      private attachOutsideClickListener() {
            if (this.outsideClickListenerAttached) return;
            document.addEventListener('click', this.onDocumentClickCapture, true);
            this.outsideClickListenerAttached = true;
            this.$once('hook:beforeDestroy', () => this.detachOutsideClickListener());
      }

      private detachOutsideClickListener() {
            if (!this.outsideClickListenerAttached) return;
            document.removeEventListener('click', this.onDocumentClickCapture, true);
            this.outsideClickListenerAttached = false;
      }

      private onDocumentClickCapture = (e: MouseEvent) => {
            const target = e.target as HTMLElement | null;
            if (!target) return;
            // allow clicking inside menu itself
            if (target.closest('.message-options__wrapper')) return;
            // close any open message options anywhere
            const openEls = document.getElementsByClassName('open');
            for (let i = openEls.length - 1; i >= 0; i--) {
                  openEls[i].classList.remove('open');
            }
            this.detachOutsideClickListener();
      }
}
